import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.events-slider' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--events-slider' )[0], {
          pagination: false,
          perPage: 3,
          perMove: 1,
          gap: '32px',
          keyboard: true,
          breakpoints: {
            1024: {
              perPage: 2,
            },
            640: {
              perPage: 1,
            },
          },
        } );

        const progressBar = splide.root.querySelector( '.events-slider .service-slider__progress-bar' );

        if ( progressBar ) {
          splide.on( 'mounted refresh move', function( newIndex, prevIndex, destIndex ) {
            const end = splide.Components.Controller.getEnd() + 1;
            const rate = Math.min( ( splide.index + 1 ) / end, 1 );
            progressBar.style.width = String( 100 * rate ) + '%';
          } );
        }

        splide.mount();

        $( window ).on( 'resize', function() {
          if ( $( component ).find( '.splide' ).hasClass( 'is-overflow' ) ) {
            $( component ).find( '.slider-navigation' ).removeClass( 'hidden' );
          } else {
            $( component ).find( '.slider-navigation' ).addClass( 'hidden' );
          }
        } );

        if ( $( component ).find( '.splide' ).hasClass( 'is-overflow' ) ) {
          $( component ).find( '.slider-navigation' ).removeClass( 'hidden' );
        } else {
          $( component ).find( '.slider-navigation' ).addClass( 'hidden' );
        }
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'events-slider', COMPONENT );
} )( app );
